var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['v-image', _vm.isActive && 'v-image--active'],style:({ backgroundImage: !!_vm.src && ("url('" + _vm.src + "')") }),attrs:{"alt":_vm.alt,"role":"img"}})}
var staticRenderFns = []

export { render, staticRenderFns }